export class ListThreatHuntingScanRequestsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ThreatHuntingStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListThreatHuntingScanRequestsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
